import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import api from "@/lib/api";

export default function PrivacySettingsDialog({ trigger, defaultOpen = false, onClosed }) {
  const [open, setOpenState] = useState(defaultOpen);
  const setOpen = (v) => { setOpenState(v); if (!v) onClosed?.(); };
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) api.privacySettings().then(setS).catch(() => toast.error("Impostazioni non disponibili")); }, [open]);
  const save = async () => {
    if (!s.text.trim()) return toast.error("Il testo non può essere vuoto");
    setBusy(true);
    try { await api.savePrivacySettings(s); toast.success("Informativa privacy salvata"); setOpen(false); } catch (e) { toast.error(e.response?.data?.detail || "Errore"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || <Button variant="outline" className="gap-2 border-border" data-testid="open-privacy-settings-button"><ShieldCheck className="h-4 w-4" /> Privacy generale</Button>}
      </DialogTrigger>
      <DialogContent className="bg-background border-border max-w-2xl" data-testid="privacy-settings-dialog">
        <DialogHeader><DialogTitle>Informativa privacy generale</DialogTitle><DialogDescription>Mostrata su <code>/privacy</code> e per i concorsi senza informativa specifica (testo o PDF caricati nel concorso).</DialogDescription></DialogHeader>
        {s && (
          <div className="space-y-3">
            <div className="grid sm:grid-cols-2 gap-3">
              <div className="space-y-1"><Label>Titolo</Label><Input value={s.title || ""} onChange={(e) => setS({ ...s, title: e.target.value })} data-testid="privacy-settings-title" /></div>
              <div className="space-y-1"><Label>Titolare del trattamento</Label><Input value={s.holder || ""} onChange={(e) => setS({ ...s, holder: e.target.value })} placeholder="Ragione sociale, indirizzo, email" data-testid="privacy-settings-holder" /></div>
            </div>
            <div className="space-y-1"><Label>Testo dell'informativa</Label><Textarea rows={12} value={s.text} onChange={(e) => setS({ ...s, text: e.target.value })} data-testid="privacy-settings-text" /></div>
            <div className="flex items-center justify-between text-xs text-muted-foreground"><span>{s.updated_at ? `Ultima modifica: ${new Date(s.updated_at).toLocaleString("it-IT")}` : "Testo predefinito"}</span><a href="/privacy" target="_blank" rel="noreferrer" className="underline" data-testid="privacy-settings-preview">Anteprima /privacy</a></div>
            <Button onClick={save} disabled={busy} className="w-full" data-testid="privacy-settings-save">{busy ? "Salvataggio…" : "Salva"}</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
